export const validStartTimes = (times: string) => {
  if (times === "") {
    return false;
  }

  const startTimesRegex = /[0-9]{2,2}-[0-9]{2,2}/;

  return startTimesRegex.test(times);
};

export const genStartTimesOptions = () => {
  const options: Array<[string, string]> = [];

  // ３時間刻み
  for (let i = 0; i < 8; i++) {
    const min = i * 3 < 10 ? `0${i * 3}` : `${i * 3}`;
    const max = (i + 1) * 3 < 10 ? `0${(i + 1) * 3}` : `${(i + 1) * 3}`;

    options.push([`${min}-${max}`, `${min}:00 ~ ${max}:00 開始`]);
  }
  return options;
};

export const parseStartTimesQuery = (
  query: string | null,
  type: "min" | "max"
) => {
  if (query === null) {
    return undefined;
  }

  if (!validStartTimes(query)) {
    return undefined;
  }

  const split = query.split("-");

  return type === "min" ? Number(split[0]) * 3600 : Number(split[1]) * 3600;
};
